import useUserPermissions from "../../../../../common/utils/user/permissions/use-user-permissions";
import orderFinishedListingUserPermissionDefinition from "./order-finished-listing-user-permission";

const useOrderFinishedListingUserPermissions = () => {
  return useUserPermissions(orderFinishedListingUserPermissionDefinition);
};

export default useOrderFinishedListingUserPermissions;
